"use client";
import { useRouter } from "next/navigation";
import { ContactsPage } from "@/components/contatti/ContactsPage";

export default function Contatti() {
  const router = useRouter();
  return <ContactsPage onBackToHome={() => router.push("/")} />;
}
